import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  color: #a4abbd;

  a, a:visited {
    color: #a4abbd;
  }

  img {
    margin-top: 0.5rem;
    height: 40px;
  }
`;
